import {KENO_DIVIDER, KENO_PAY_OUT} from "@dicether/state-channel";
import ClassNames from "classnames";
import * as React from "react";

import * as Style from "./PayoutTable.scss";

interface EntryProps {
    hits: number;
    payout: number;
    won?: boolean;
}

const Entry = ({hits, payout, won}: EntryProps) => {
    const className = ClassNames(Style.entry, {
        [Style.entry_won]: won === true,
        [Style.entry_lost]: won === false,
    });

    return (
        <div className={className}>
            <span>{hits} Hits</span>
            <span>{payout}x</span>
        </div>
    );
};

export interface Props {
    selectedTiles: number;
    numHits?: number;
}

const PayoutTable = ({selectedTiles, numHits}: Props) => {
    return (
        <div className={Style.payoutTable}>
            {[...Array(selectedTiles + 1).keys()].map((t) => (
                <Entry
                    key={t}
                    hits={t}
                    payout={KENO_PAY_OUT[selectedTiles][t] / KENO_DIVIDER}
                    won={numHits === t ? KENO_PAY_OUT[selectedTiles][numHits] > 0 : undefined}
                />
            ))}
        </div>
    );
};

export default PayoutTable;
